/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Filter_ForcedInputs */



/**
* | output |
* | --- |
* | "Forced" |
*
* @param {Editor_Filter_ForcedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_filter_forced = /** @type {((inputs?: Editor_Filter_ForcedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Filter_ForcedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Force")
	if (locale === "de") return /** @type {LocalizedString} */ ("Gezwungen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Costretto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Принужденный")
	if (locale === "es") return /** @type {LocalizedString} */ ("Forzado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("被迫")
	if (locale === "ja") return /** @type {LocalizedString} */ ("強制された")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मजबूर")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Forçado")
	return /** @type {LocalizedString} */ ("Forced")
});